import Http from './http';

export class AnalysisEngineService {
	static httpClient = Http.create(import.meta.env.VITE_GW_SERVICE);

	/** A API devolve `BaseResponse<string>`: a letra vem em `data` (nula quando o caso ainda não tem análise). */
	static async getRatingForCaseId(caseId: string): Promise<{ data: string | null }> {
		const response = await this.httpClient.get(`policy/${caseId}/rating`);

		return response.data as { data: string | null };
	}
}
